import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./productPerformanceList.scss"

function DataProtectionList() {
  const {t} = useTranslation()

  return (
    <div className='container-product-performance-list'>
      <div className="texts-product-performance-list">
        
        <SectionComponent title={t("database.in_cloud_db.title")} text={t("database.in_cloud_db.section_text")}>
        </SectionComponent>

        <SectionComponent title={t("database.on_premise.title")} text={t("database.on_premise.section_text_1")}>
          <p>{t("database.on_premise.section_text_2")}</p>
        </SectionComponent>

      </div>
    </div>
  )
}

export default DataProtectionList